import classNames from "classnames";
import Button from "components/Leasing/components/leasing.c.button";
import {
  prePareQueryRequest,
  getLastItem,
} from "components/Leasing/utils/leasing.u";
import { differenceInDays, format } from "date-fns";
import _ from "lodash";
import { useEffect, useState } from "react";
import ReactExport from "react-data-export";
import API from "../api/api.main";
import { Auth } from "aws-amplify";
import axios from "axios";
import numeral from "numeral";
import { getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import { DateTime } from "luxon";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let source = axios.CancelToken.source();

function AgingReport({ sandboxDate }) {
  const [loading, setLoading] = useState(false);
  const [aging, setAging] = useState([]);
  const [count, setCount] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (finished) {
      const doc = document.getElementById("export-excel-leasing-aging");
      doc.click();
    }
  }, [finished]);

  const getDefaultQuery = () => {
    const objQuery = {
      Limit: 100,
      loan_id: "",
      ScanIndexForward: false,
      status: "",
      category: "",
      min: "",
      max: "",
      fields: "",
    };
    return objQuery;
  };

  const fetchLeasingLoan = async (firstLoading = true) => {
    try {
      setLoading(firstLoading);
      setFinished(false);
      setCount(0);
      let localQuery = getDefaultQuery();
      let datas = [];
      let lastItem = null;

      do {
        const data = await API.get("MoneyHubAdmin", `/leasing/loan`, {
          queryStringParameters: {
            ...prePareQueryRequest(_.cloneDeep(localQuery)),
            ExclusiveStartKey: getLastItem(lastItem),
            showInstallment: "true",
            paid_date: getCurrentLocalDateTime(new Date(sandboxDate)).fullDate,
            isNew: true,
            // loan_id: "690006090",
            fields:
              "installments,loan_id,phone_number,loan_status,requestamount,createdAt,name,lastname,capitalRemain",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
          cancelToken: source?.token,
        });

        let leasing_loans = data?.leasing_loans;
        lastItem = data?.lastItem;

        let index = 0;
        for (let leasing_loan of leasing_loans) {
          if (leasing_loan?.loan_status === "DONE") continue;

          let objPrinciple = {
            notDue: leasing_loan?.capitalRemain,
            30: 0,
            "31_90": 0,
            "91_180": 0,
            "181_365": 0,
            365: 0,
            total: 0,
          };

          for (const installment of leasing_loan?.installments) {
            const filter_last_pre_installments =
              installment?.pre_installments?.filter((pre_installment) => {
                const beginDateActual =
                  pre_installment?.beginDatePenalty === "-"
                    ? pre_installment?.beginDate
                    : pre_installment?.beginDatePenalty;
                const paidDate = DateTime.fromJSDate(
                  new Date(pre_installment?.paidDate)
                ).toFormat("yyyy-MM-dd");

                if (beginDateActual <= sandboxDate || paidDate <= sandboxDate) {
                  return pre_installment;
                }
              });
            const last_pre_installment = _.last(filter_last_pre_installments);
            if (last_pre_installment) {
              const diffDays = differenceInDays(
                new Date(sandboxDate),
                new Date(last_pre_installment?.dueDate)
              );

              if (diffDays > 0) {
                if (diffDays <= 30) {
                  objPrinciple["30"] +=
                    last_pre_installment?.principle -
                    last_pre_installment?.paidPrinciple;
                } else if (diffDays <= 90) {
                  objPrinciple["31_90"] +=
                    last_pre_installment?.principle -
                    last_pre_installment?.paidPrinciple;
                } else if (diffDays <= 180) {
                  objPrinciple["91_180"] +=
                    last_pre_installment?.principle -
                    last_pre_installment?.paidPrinciple;
                } else if (diffDays <= 365) {
                  objPrinciple["181_365"] +=
                    last_pre_installment?.principle -
                    last_pre_installment?.paidPrinciple;
                } else {
                  objPrinciple["365"] +=
                    last_pre_installment?.principle -
                    last_pre_installment?.paidPrinciple;
                }
              }
            }
          }

          objPrinciple["notDue"] =
            objPrinciple["notDue"] -
            objPrinciple["30"] -
            objPrinciple["31_90"] -
            objPrinciple["91_180"] -
            objPrinciple["181_365"] -
            objPrinciple["365"];

          objPrinciple["total"] =
            objPrinciple["notDue"] +
            objPrinciple["30"] +
            objPrinciple["31_90"] +
            objPrinciple["91_180"] +
            objPrinciple["181_365"] +
            objPrinciple["365"];

          leasing_loans[index] = {
            ...leasing_loan,
            ...objPrinciple,
          };
          index++;
        }

        datas = [...datas, ...leasing_loans];
        setCount(datas?.length);
      } while (lastItem);

      setAging(datas);
      setFinished(true);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoading(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { patternType: "solid", fgColor: { rgb: "FFFFFF" } };
      // i == data.length - 1
      //   ? { patternType: "solid", fgColor: { rgb: "FEFF54" } }
      //   : { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 = { patternType: "solid", fgColor: { rgb: "FFFFFF" } };
      // i == data.length - 1
      //   ? { fgColor: { rgb: "FFFFFF" } }
      //   : { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i].loan_id || ""}`,
          style: { font: { sz: 14 }, alignment: "right", fill: filled_col_0 },
        },
        {
          value: `${data[i]?.name} ${data[i]?.lastname}`,
          style: { font: { sz: 14 }, alignment: "right" },
        },
        {
          value: data[i].loan_status || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i].notDue,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][30],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["31_90"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["91_180"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["181_365"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][365],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: +data[i].total,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: `${format(new Date(data[i].createdAt), "yyyy-MM-dd")}`,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
      ]);
    }
    return result;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "REFERENCE",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "NAME",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "STATUS",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "NOT DUE",
          width: { wch: 16 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "0 - 30",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "31 - 90",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "91 - 180",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "181 - 365",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "> 365",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Total",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 14 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(aging),
    },
  ];

  return (
    <div>
      <Button
        disabled={loading}
        loading={loading}
        onClick={fetchLeasingLoan}
        className={classNames(
          "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
          {
            "bg-green-500": !loading,
            "bg-gray-400": loading,
          }
        )}
      >
        {loading ? `Loading... ${count}` : "Report Aging"}
      </Button>

      <ExcelFile
        filename={`LEASING_AGING_${format(
          sandboxDate ? new Date(sandboxDate) : new Date(),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-leasing-aging" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="Principle"></ExcelSheet>
      </ExcelFile>
    </div>
  );
}

export default AgingReport;
